module.exports = "https://coursera_assets.s3.amazonaws.com/images/5d639bd30833377214257115daa5630a.jpg";